document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-featured-carousel]').forEach((carouselWrapper) => {
    const slider = carouselWrapper.querySelector('ul');
    const speed = 0.5;

    // Duplicate the content for infinite scroll
    slider.innerHTML += slider.innerHTML;

    let translateX = 0;
    let animationFrame;

    function animate() {
      translateX -= speed;
      if (Math.abs(translateX) >= slider.scrollWidth / 2) {
        translateX = 0;
      }

      slider.style.transform = `translateX(${translateX}px)`;
      animationFrame = requestAnimationFrame(animate);
    }

    function pause() {
      cancelAnimationFrame(animationFrame);
    }

    function resume() {
      animationFrame = requestAnimationFrame(animate);
    }

    // Initial styles
    slider.style.whiteSpace = 'nowrap';
    slider.style.display = 'flex';
    slider.style.transition = 'none';
    slider.style.willChange = 'transform';

    carouselWrapper.addEventListener('mouseenter', pause);
    carouselWrapper.addEventListener('mouseleave', resume);

    resume();
  });
});
